import { Autocomplete, Button, Paper, Text, Box, Flex, Group } from '@mantine/core'
import classes from './Managepallets.module.css';
import { IoAdd } from "react-icons/io5";
import { IoMdSearch } from "react-icons/io";

import React, { memo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TablePalletsDataComponent from './TablePalletsData.component';
import InputButton from '../../../CustomComponent/InputFileButton/Inputbutton.component';
import { baseUrl } from '../../../Constants/constant';
import SampleFile from '../../../CustomComponent/DownloadSampleFile/Samplefile.component';

const ManagePallets = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [sendsearch, setSendsearch] = useState('');

  const handlechange = (value: any) => {
    setSearch(value);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSendsearch(search);
    }, 500); // Debounce input for better performance

    return () => clearTimeout(timeout); // Cleanup on re-renders
  }, [search]);

  return (
    <>

      <Paper shadow="xs" p="xs" radius="md">
        <Box>
          <Flex
            style={{ justifyContent: 'space-between' }}
            align="center"
          >
            <Box>
              <Text ta="left">Pallets</Text>
            </Box>
            <Group>
              <Autocomplete
                // label="Your favorite library"
                value={search}
                onChange={handlechange}
                placeholder="Search by Pallet name"
                leftSection={<IoMdSearch />}
              />

              <Button
                className={classes.addbtn}
                variant="gradient"
                gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                leftSection={<IoAdd size={20} />}
                onClick={() => navigate('/pallets/addpallets')}
              >
                Add Pallets
              </Button>
              <InputButton
                url={`${baseUrl}admin/pallets/import-file`}
              />
              <SampleFile type={'pallet'} />
            </Group>
          </Flex>
          <TablePalletsDataComponent editLink={'/pallets/addpallets'} search={sendsearch} />
        </Box>
      </Paper>
    </>
  )
}

export default memo(ManagePallets)
